<template>
    <v-layout wrap align-center>
        <v-flex xs12>
            <text-field-label
                v-model="times"
                :type="'time'"
                :disabled="disabled"
                :rules="rulesData"
                :editable="editable"
                @focus="e => $emit('focus', e)"
                @blur="e => $emit('blur', e)"
                @update:error="e => $emit('update:error', e)"
            />
        </v-flex>
    </v-layout>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { getLocale } from '../../translations';
import SelectLabel from './SelectLabel.vue';
import TextFieldLabel from './TextFieldLabel.vue';

@Component({
    name: 'TimeTextField',
    components: {
        TextFieldLabel,
    },
})
export default class TimeTextField extends Vue {
    @Prop({ default: '' }) value: string;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: '' }) label: string;
    @Prop({ default: () => [] }) rules: [];
    @Prop({ default: true }) editable: boolean;

    @Watch('value', { immediate: true })
    onValueChanged(val: string): void {
        this.times = val;
    }
    @Watch('times', { immediate: true })
    onTimesChanged(val: string): void {
        this.input(val);
    }
    @Emit()
    public input(value: string) {}

    times = '';

    get rulesData(): Array<any> {
        return this.rules;
    }
}
</script>
